import React from 'react';
import Helmet from 'react-helmet';

import boldWoff2 from '@xingternal/designkit/Shared/Assets/Web/XING-Sans-Bold.woff2';
import boldWoff from '@xingternal/designkit/Shared/Assets/Web/XING-Sans-Bold.woff';

/**
 * @TODO: REVERT this Helmet injection once the Xing Sans XDL font is being imported properly from global-styles
 */
const HelmetFont = () => {
  const familyName = 'Xing Sans XDL';
  const fonts = {
    bold: {
      fontWeight: 700,
      fontStyle: 'normal',
      woff2: boldWoff2,
      woff: boldWoff,
    },
  };
  const usedFonts = [fonts.bold];
  const style = [
    {
      cssText: usedFonts
        .map(({ fontWeight, fontStyle, woff, woff2 }) => {
          return `
            @font-face {
              font-family: ${familyName};
              font-display: block;
              font-style: ${fontStyle};
              font-weight: ${fontWeight};
              src: url(${woff2}) format("woff2"),
              url(${woff}) format("woff");
            }
          `;
        })
        .join('')
        .replace(/\n|^\s+/gm, ''),
    },
    {
      cssText: `body {font-family: '${familyName}', 'Trebuchet MS', Arial, 'Helvetica Neue', sans-serif;}`,
    },
  ];

  const link = usedFonts.map(({ woff2 }) => ({
    href: woff2,
    rel: 'preload',
    as: 'font',
    crossorigin: 'anonymous',
    type: 'font/woff2',
  }));

  return <Helmet style={style} link={link} />;
};

export default HelmetFont;
